import { CabecalhoDePagina, EstadoCarregando, EstadoDeErro } from "@base/ui";
import { mensagemDoErro } from "../../../shared/http/mensagem-de-erro";
import { useCredencialGoogle, useCredencialMeta } from "../application/conexoes.contexto";
import {
  AcessoDaMonteAoGoogle,
  AcessoDaMonteAoMeta,
  AcessoDaMonteAOpenAi,
  CAMINHO_DAS_CONEXOES_DA_MONTE,
} from "./acesso-da-monte";

export { CAMINHO_DAS_CONEXOES_DA_MONTE };

/** Acessos da equipe Monte: Meta, Google e OpenAI. Um de cada, para todas as clínicas. */
export function PaginaDeConexoesDaMonte() {
  const meta = useCredencialMeta();
  const google = useCredencialGoogle();

  return (
    <div className="flex flex-col gap-secao">
      <CabecalhoDePagina
        rotulo="Configurações da Monte"
        titulo="Conexões"
        descricao="Token do Meta, acesso ao Google Ads e a chave da OpenAI. Um de cada, usado por todas as clínicas."
      />
      {meta.isPending || google.isPending ? (
        <EstadoCarregando rotulo="Carregando as conexões" />
      ) : meta.isError || google.isError ? (
        <EstadoDeErro mensagem={mensagemDoErro(meta.error ?? google.error)} />
      ) : (
        <div className="flex flex-col gap-bloco">
          <AcessoDaMonteAoMeta
            nomeNoMeta={meta.data.nomeNoMeta}
            atualizadaEm={meta.data.atualizadaEm}
            configurada={meta.data.configurada}
            podeEditar
          />
          <AcessoDaMonteAoGoogle
            nomeNoGoogle={google.data.nomeNoGoogle}
            atualizadaEm={google.data.atualizadaEm}
            configurada={google.data.configurada}
            podeEditar
          />
          <AcessoDaMonteAOpenAi podeEditar />
        </div>
      )}
    </div>
  );
}
